const STORAGE_KEY = "nema_admin_search_history_v1";
const MAX_ITEMS = 8;

export function readAdminSearchHistory() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === "string" && item.trim()) : [];
  } catch {
    return [];
  }
}

export function pushAdminSearchHistory(query) {
  const trimmed = String(query || "").trim();
  if (!trimmed) return readAdminSearchHistory();
  const next = [trimmed, ...readAdminSearchHistory().filter((item) => item.toLowerCase() !== trimmed.toLowerCase())].slice(
    0,
    MAX_ITEMS
  );
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore quota */
  }
  return next;
}

export function clearAdminSearchHistory() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
  return [];
}
